module.exports = __webpack_public_path__ + "static/media/aman.377ff22a.jpg";